// extracted by mini-css-extract-plugin
export default {"navigation":"mobileNavigation_navigation__j50Zo","slide-in-bottom":"mobileNavigation_slide-in-bottom__qJq39","active":"mobileNavigation_active__tkKe+"};